import { createSelector } from '@reduxjs/toolkit';
import { Tag, TagsState } from './types';

const selectBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.tagsReducer,
);

export const selectTagsForPerson = createSelector(
	selectBase,
	(state: TagsState) => state.tagsForPerson,
);

export const selectTagsForOrder = createSelector(
	selectBase,
	(state: TagsState) => state.tagsForOrder,
);

export const selectTagsForPersonMap = createSelector(
	selectTagsForPerson,
	(tags: Tag[]) => {
		const map = new Map<string, { value: string; color: string }>();
		tags.forEach(tag => {
			map.set(tag.name, {
				value: tag.id?.toString(),
				color: tag.color,
			});
		});
		return map;
	},
);

export const selectTagsForOrderMap = createSelector(
	selectTagsForOrder,
	(tags: Tag[]) => {
		const map = new Map<string, { value: string; color: string }>();
		tags.forEach(tag => {
			map.set(tag.name, {
				value: tag.id?.toString(),
				color: tag.color,
			});
		});
		return map;
	},
);

export const selectOrderTagsOptions = createSelector(
	selectBase,
	(state: TagsState) => {
		return state.tagsForOrder.map(tag => {
			return { label: tag.name, value: tag.id, color: tag.color };
		});
	},
);

export const selectPersonTagsOptions = createSelector(
	selectBase,
	(state: TagsState) => {
		return state.tagsForPerson.map(tag => {
			return { label: tag.name, value: tag.id, color: tag.color };
		});
	},
);

export const selectOrderTagsNames = createSelector(
	selectBase,
	(state: TagsState): Map<string, string> => {
		const map = new Map();
		state.tagsForOrder.forEach(tag => {
			map.set(tag.slug, tag.name);
		});

		return map;
	},
);

export const selectPersonTagsNames = createSelector(
	selectBase,
	(state: TagsState): Map<string, string> => {
		const map = new Map();
		state.tagsForPerson.forEach(tag => {
			map.set(tag.slug, tag.name);
		});

		return map;
	},
);

export const selectOrderSlugTagsMap = createSelector(
	selectBase,
	(state: TagsState): Map<string, Tag> => {
		const map = new Map();
		state.tagsForOrder.forEach(tag => {
			map.set(tag.slug, tag);
		});

		return map;
	},
);

export const selectPersonSlugTagsMap = createSelector(
	selectBase,
	(state: TagsState): Map<string, Tag> => {
		const map = new Map();
		state.tagsForPerson.forEach(tag => {
			map.set(tag.slug, tag);
		});

		return map;
	},
);

export const selectOrderTagsSlugNamesMap = createSelector(
	selectBase,
	(state: TagsState) => {
		const map = new Map();
		state.tagsForOrder.forEach(tag => {
			map.set(tag.name, tag.slug);
		});

		return map;
	},
);

export const selectPersonTagsSlugNamesMap = createSelector(
	selectBase,
	(state: TagsState) => {
		const map = new Map();
		state.tagsForPerson.forEach(tag => {
			map.set(tag.name, tag.slug);
		});

		return map;
	},
);
